import { FunctionComponent, ReactElement } from "react";
import styled from "styled-components";
import Image from "next/image";

import { colours } from "@/utils";
import MarketingLink from "../../MarketingLink";
import { Device } from "@/utils/device";

type ImagePillContentProps = {
  id: string;
  title: ReactElement;
  href: string;
  subheading: string;
  copy: (string | ReactElement)[];
  linkText: string;
  imagePath: string;
  altText?: string;
};

const ImagePillContent: FunctionComponent<ImagePillContentProps> = (props) => {
  return (
    <S.Section id={props.id}>
      <S.TextContent>
        <S.TitlePosition>{props.title}</S.TitlePosition>
        <S.Subheading>{props.subheading}</S.Subheading>
        <S.Copy>
          {props.copy.map((text) => (
            <>
              {text}
              <br />
              <br />
            </>
          ))}
        </S.Copy>
        <S.LinkContainer>
          <MarketingLink
            href={props.href}
            linkText={props.linkText}
            textColour={colours.marketingNavy}
            colour={colours.marketingNavy}
          />
        </S.LinkContainer>
      </S.TextContent>
      <S.ImageContainer>
        <Image
          src={props.imagePath}
          alt={props.altText || ""}
          layout="fill"
          objectFit="cover"
          objectPosition="right"
        />
      </S.ImageContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  background-color: ${colours.shell};
  display: flex;
  flex-direction: column;
  color: #0b0b29;
  margin-bottom: 2rem;
  overflow: hidden;

  @media (min-width: ${Device.mobile}) {
    margin-bottom: 4rem;
  }

  @media (min-width: ${Device.tablet}) {
    flex-direction: row;
  }
`;

S.TextContent = styled.div`
  padding: 4rem 10%;
  width: 100%;

  @media (min-width: ${Device.tablet}) {
    padding: 5rem 10%;
  }

  @media (min-width: ${Device.desktop}) {
    padding: 6rem 10% 5rem 10%;
  }
`;

S.TitlePosition = styled.h2`
  font-family:
    Roxborough CF,
    sans-serif;
  margin-bottom: 3rem;

  @media (min-width: ${Device.desktop}) {
    margin-bottom: 5rem;
  }
`;

S.Subheading = styled.p`
  margin-bottom: 2rem;
  font-weight: 600;

  @media (min-width: ${Device.tablet}) {
    font-size: 1.8rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 2rem;
  }
`;

S.Copy = styled.p`
  margin-bottom: 2rem;
  white-space: pre-line;

  @media (min-width: ${Device.tablet}) {
    font-size: 1.8rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 2rem;
  }
`;

S.LinkText = styled.p`
  text-decoration: underline;
  padding-bottom: 1.5rem;
`;

S.LinkContainer = styled.div`
  padding-top: 1.5rem;

  @media (min-width: ${Device.desktop}) {
    padding-top: 5rem;
  }
`;

S.ImageContainer = styled.div`
  position: relative;
  align-self: flex-end;
  width: 90vw;
  height: 320px;
  overflow: hidden;
  border-radius: 50% 0 0 50%;

  @media (min-width: ${Device.tablet}) {
    align-self: center;
  }

  @media (min-width: ${Device.desktop}) {
    height: 500px;
  }
`;

export default ImagePillContent;
